export default "__VITE_ASSET__LhYm3c9W__"